import { Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { UntilDestroy } from '@ngneat/until-destroy';
import { APIResponse, Data,  } from '../../models';
import {Issue} from "../../models/issues.model";
import * as qs from "qs";
import { IssuePositionLocked } from '../../models/issuePositionLocked.model';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class IssuesService {

  constructor(private httpClient: HttpClient) {}

  public loadIssues(productId: number) {
    const query: string = qs.stringify(
      {
        filters: {
          productsConcerned: {
            $in: productId
          },
          startDate: {
            $lte: new Date().toISOString(),
          },
          $or: [
            { endDate: { $gte: new Date().toISOString() } },
            { endDate: { $null: true } },
          ],
        }
      }, { encode: false });

    return this.httpClient
      .get<APIResponse<Data<Issue>[]>>(`${environment.baseUrl}/issues?${query}`)
      .pipe(
        take(1),
        map((response) => response.data[0])
      )
  }

  public loadIssuePositionLocked(userProductWalletId: number, issueId: number): Observable<IssuePositionLocked> {
    return this.httpClient
      .get<IssuePositionLocked[]>(`${environment.baseUrl}/user-product-wallets/${userProductWalletId}/issues/${issueId}/latest-position-locked`)
      .pipe(
        take(1),
        map((response) => response[0])
      )
  }
}
